import React from "react";

interface HeaderProps {
  siteTitle?: string;
}

const Header: React.FC<HeaderProps> = ({ siteTitle }) => (
  <header>
    {/* <Container>
      <Navbar collapseOnSelect expand="xl" variant="dark">
        <Navbar.Brand href="/">
          <img
            src={logo}
            width="56"
            height="56"
            className="d-inline-block align-top"
            alt="Lotus Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav justify-content-end">
          <Nav className="ml-auto">
            <Link to="/" className="nav-link" activeClassName="active-link">
              Home
            </Link>
            <Link
              to="/install"
              className="nav-link"
              activeClassName="active-link"
            >
              Install
            </Link>
            <a
              href="https://github.com/DecliningLotus/gatsby-lotus-starter"
              className="nav-link"
            >
              Github
            </a>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </Container> */}
  </header>
);

export default Header;
